/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PersonName from './person-name';
import PersonNameDetail from './person-name-detail';
import PersonNameUpdate from './person-name-update';
import PersonNameDeleteDialog from './person-name-delete-dialog';

const PersonNameRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PersonName />} />
    <Route path="new" element={<PersonNameUpdate />} />
    <Route path=":id">
      <Route index element={<PersonNameDetail />} />
      <Route path="edit" element={<PersonNameUpdate />} />
      <Route path="delete" element={<PersonNameDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PersonNameRoutes;
